import { z } from "zod";

const translationPath = "components.step.errors.";

export const stepSchema = z.object({
  questionAlternative: z
    .string({
      required_error: translationPath + "alternative",
    })
    .nullish(),
  justification: z.string().nullish(),
  answer: z.string().nullish(),
});

export type TStepForm = z.infer<typeof stepSchema>;
